import type { LoginContext } from 'features/auth/types';
import { getUserData } from 'features/auth/utils/storage';

export type LoggedInUserOrganizationType = 'Designer' | 'Supplier';

export type SegmentDefaultEventProperties = {
  loggedInUserId: string;
  loggedInUserOrganizationId: string;
  loggedInUserOrganizationType: LoggedInUserOrganizationType;
};

const toLoggedInUserOrganizationType = (organizationType: number): LoggedInUserOrganizationType =>
  organizationType === 1 ? 'Designer' : 'Supplier';

const toSegmentUserContext = (
  loginContext: LoginContext | null | undefined
): SegmentDefaultEventProperties | null => {
  if (!loginContext) {
    return null;
  }
  return {
    loggedInUserId: loginContext.id,
    loggedInUserOrganizationId: String(loginContext.organizationId),
    loggedInUserOrganizationType: toLoggedInUserOrganizationType(loginContext.organizationType),
  };
};

export const getSegmentDefaultEventProperties = (): SegmentDefaultEventProperties | null => {
  const { loginContext } = getUserData();
  return toSegmentUserContext(loginContext);
};
